export default __webpack_public_path__ + "static/media/tolu.b1349464.jpg";